export enum EmailTemplates {
	UserSignUpInvite = 'user-sign-up-invite'
}